// RB-MY01-PalmGarden.web/src/components/PlantForm/components/FormSections/Classification.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const Classification: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Plant Classification" 
      icon={<i className={sectionThemes.classification.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.classification.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Classification section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(Classification);
